module.exports = __webpack_public_path__ + "img/FRPProducts.10747289.png";